import { useMemo } from 'react';

import { NEPAL_PROVINCES } from '@/lib/nepal-locations';

export interface LocationOption {
    id: number;
    name: string;
}

export function useNepalStates() {
    const states = useMemo<LocationOption[]>(() => (
        NEPAL_PROVINCES.map((province, index) => ({ id: index + 1, name: province.name }))
    ), []);

    return { states, loading: false };
}

export function useNepalCities(stateId: number | null) {
    const cities = useMemo<LocationOption[]>(() => {
        if (!stateId) return [];
        const province = NEPAL_PROVINCES[stateId - 1];
        if (!province) return [];
        return province.districts.map((district, index) => ({ id: index + 1, name: district }));
    }, [stateId]);

    return { cities, loading: false };
}
